import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { VERSION } from "../../../environments/version";

const materialModules = [MatIconModule];

@Component({
    standalone: true,
    selector: "app-footer",
    imports: [CommonModule, RouterModule, TranslateModule, ...materialModules],
    templateUrl: "./footer.component.html",
    styleUrl: "./footer.component.scss"
})
export class FooterComponent {
    readonly appVersion = VERSION.full;
    readonly buildDate = new Date(VERSION.buildDate);

    readonly socialLinks = [
        {
            href: "https://www.instagram.com/thecoolrhyno/",
            icon: "assets/icons/instagram.webp",
            altKey: "auto_instagram"
        },
        {
            href: "https://x.com/thecoolrhyno",
            icon: "assets/icons/twitter.webp",
            altKey: "auto_twitter"
        },
        {
            href: "https://www.tiktok.com/@thecoolrhyno",
            icon: "assets/icons/tiktok.webp",
            altKey: "auto_tiktok"
        },
        {
            href: "https://www.linkedin.com/company/the-cool-rhyno/",
            icon: "assets/icons/linkedin.webp",
            altKey: "auto_linkedin"
        }
    ] as const;
}
